const ModalContent = ({ children }) => (
    <section className="modal-card-body">
        {children}
    </section>
);

const ModalControl = ({ children }) => (
    <footer className="modal-card-foot">
        {children}
    </footer>
);

const Modal = ({ title, isActive, onExit, children }) => {

    const CloseButton = () => {
        if (!onExit) {
            return null;
        }

        return (
            <button onClick={onExit} className="delete" aria-label="close"></button>
        );
    };

    return (
        <div className={`modal is-clipped ${isActive ? "is-active" : ""}`}>
            <div className="modal-background"></div>
            <div className="modal-card">
                <header className="modal-card-head">
                    <p className="modal-card-title">{title}</p>
                    <CloseButton />
                </header>

                {children}
            </div>
        </div>
    );
};

export { Modal, ModalContent, ModalControl };
